webpackJsonp([62],{

/***/ 1010:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('action-sidebar',{attrs:{"title":"Detalle","value":_vm.value},on:{"close-modal":_vm.closeModal}},[_c('v-layout',{attrs:{"wrap":"","mt-5":"","ml-5":"","mr-4":""}},[_c('v-flex',{attrs:{"xs3":""}},[_c('p',{staticClass:"font-weight-bold body-1"},[_vm._v("Nombre :")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs9":""}},[_c('p',{staticClass:"body-1"},[_vm._v(_vm._s(_vm.dataResponse.name))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('p',{staticClass:"font-weight-bold body-1"},[_vm._v("Descripción:")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs9":""}},[_c('p',{staticClass:"body-1"},[_vm._v(_vm._s(_vm.dataResponse.description))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('p',{staticClass:"font-weight-bold body-1"},[_vm._v("Módulos:")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs9":""}},[_c('p',{staticClass:"body-1"},[(_vm.dataResponse.template)?_c('v-expansion-panel',{staticClass:"expansion-panel-template"},_vm._l((_vm.dataResponse.template.roles),function(rol){return _c('v-expansion-panel-content',{key:rol.nameRole,staticClass:"transparent",attrs:{"hide-actions":_vm.lengthArray(rol.resources)}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(rol.nameRole))]),_vm._v(" "),_vm._l((rol.resources),function(resource){return _c('v-expansion-panel',{key:resource.id,staticClass:"expansion-panel-template ml-4"},[_c('v-expansion-panel-content',{staticClass:"transparent",attrs:{"hide-actions":_vm.lengthArray(resource.actions)}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(resource.name))]),_vm._v(" "),_vm._l((resource.actions),function(action){return _c('v-expansion-panel',{key:action.id,staticClass:"expansion-panel-template ml-4"},[_c('v-expansion-panel-content',{staticClass:"transparent",attrs:{"hide-actions":""}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(action.name))])])],1)})],2)],1)})],2)})):_vm._e()],1)])],1),_vm._v(" "),_c('section',{staticClass:"modal-filter-footer"},[_c('modal-sidebar-button',{attrs:{"is-loading":_vm.loading,"on-run-service":_vm.loading},on:{"cancel-button-clicked":_vm.closeModal,"accept-button-clicked":_vm.closeModal}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 515:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_template_detail_vue__ = __webpack_require__(826);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8ac042d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_template_detail_vue__ = __webpack_require__(1010);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_template_detail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8ac042d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_template_detail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 826:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_action_sidebar__ = __webpack_require__(149);



var created = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
		var query, result;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						query = {
							headers: {
								Accept: '' + 'application/vnd.apiacl.v2+json'
							}
						};
						_context.next = 3;
						return this.$http.get('template/' + this.id, query);

					case 3:
						result = _context.sent;

						this.dataResponse = result.data.data;

					case 5:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function created() {
		return _ref.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



function closeModal() {
	this.loading = true;
	this.goTo('page-template', { params: { projectId: this.projectId } });
	this.loading = false;
}

function lengthArray(array) {
	return !array.length > 0;
}

function data() {
	return {
		dataResponse: {},
		loading: false,
		value: true
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'page-template-detail',
	data: data,
	components: {
		actionSidebar: __WEBPACK_IMPORTED_MODULE_2__components_shared_action_sidebar__["default"]
	},
	created: created,
	methods: {
		closeModal: closeModal,
		lengthArray: lengthArray
	},
	props: {
		id: {
			type: [Number, String]
		},
		projectId: {
			type: [Number, String]
		}
	}
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/62.709fe0759cdae9c18434.js